export interface InvoiceBillingAddress {
  line1: string | null;
  line2: string | null;
  locality: string | null;
  region: string | null;
  postalCode: string | null;
  country: string | null;
}

export function invoiceBillingAddressLines(address: InvoiceBillingAddress): string[] {
  const street = [address.line1, address.line2].flatMap(value => (value ?? "").split(/\r\n?|\n/).map(line => line.trim()).filter(Boolean));
  const place = [address.locality, address.region].filter(Boolean).join(", ");
  const cityLine = [place, address.postalCode].filter(Boolean).join(" ");
  return [...street, cityLine, address.country ?? ""].filter(Boolean);
}
